export const envWiseBaseURL = (envURL: any): any => {
    console.log("envURL>>>>",envURL);
    switch (envURL) {
        case "":
            return "http://localhost:3000/";
        case "DEV":
            return "https://campaignautomations-dev.nw.r.appspot.com/";
        case "QA":
            return "https://automations-portal-qa-dot-campaignautomations-dev.nw.r.appspot.com/";
        default:
            return "https://automations-portal-uat-dot-campaignautomations-dev.nw.r.appspot.com/";
    }

};